module.exports = (__webpack_require__(0))(109);


//////////////////
// WEBPACK FOOTER
// delegated ./src/dialog.js from dll-reference girder_plugin_large_image
// module id = 42
// module chunks = 0